module.exports = __webpack_public_path__ + "static/media/29ADMSPC34.e1ec198f.jpg";